import { FormLabel as ChakraFormLabel, FormLabelProps as ChakraFormLabelProps } from '@chakra-ui/react';
import { ComponentStyleConfig } from '@chakra-ui/theme';

const FormLabelStyles: ComponentStyleConfig = {
  baseStyle: {
    fontWeight: 'medium',
  },
};

const FormLabel = ({ children, ...props }: ChakraFormLabelProps) => (
  <ChakraFormLabel {...props}>{children}</ChakraFormLabel>
);

export { FormLabel, FormLabelStyles };
